export default "__VITE_ASSET__BSrfNsHk__"